module.exports = __webpack_public_path__ + "img/EmployeesRoute.1d927043.svg";